import { PrimitiveAtom, useSetAtom } from 'jotai';
import { Alert, AlertColor } from '@mui/material';
import { SnackbarMessage } from '@/types';
import { snackbarMessage as SnackbarMessageState } from '@/state';
import { WorkflowStages } from '@/__generated__/graphql';

type Props = {
  atom?: PrimitiveAtom<SnackbarMessage>;
  variant?: 'filled' | 'standard' | 'outlined';
};

export const useSnackBarMessage = ({ atom = SnackbarMessageState, variant = 'filled' }: Props) => {
  const setSnackbarMessage = useSetAtom(atom);
  const showSnackBar = (message: string, severity: AlertColor) => {
    setSnackbarMessage({
      shouldShow: true,
      content: (
        <Alert sx={{ color: 'white' }} variant={variant} severity={severity}>
          {message && (
            <>
              {message}
              &nbsp;&nbsp;
            </>
          )}
        </Alert>
      ),
    });
  };

  return {
    showSnackBar,
  };
};

export const sortWorkflowStages = (workflowStages: WorkflowStages[]) => {
  return workflowStages.sort((a, b) => (a.orderInWorkflow ?? 0) - (b.orderInWorkflow ?? 0));
};
